export default "__VITE_ASSET__BxNncZXE__"